module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {

	fox.registerWidget('Layout_Promo_Auth', {

		configure: function(options) {
			this.registerOptions('', {
				template: 'layout_promo_auth'
			});

			this.callParent('configure', arguments);
		}

	}, 'Layout_Promo');
})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/layout/auth.js
// module id = 196
// module chunks = 5